import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { styled } from "@mui/material/styles";


import { useForm } from "react-hook-form";
import {
    CarePlanTypeSearchDropdown,
    DiagnosisListing,
    PlanRelatedFactorsListing,
    PlanGoalsListing,
    PlaninterventionListing,
    NursingDiagnosisSearchDropdown,
    PlanGoalsId,
    PlaninterventionId,
    diagnosisId,
    PlanrelatedId,
    DiagnosisUpdate,
    PlanRelatedFactorsUpdate,
    PlanGolsUpdate,
    PlaninterventionUpdate
} from "../../../services/nursing/NursingCarePlanServices";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Tooltip from "@mui/material/Tooltip";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import InputField from "../../../../common/components/FormFields/InputField";
import CommonTransactionPaginationTable from "../../../../common/components/CommonTable/CommonTransactionPaginationTable";
import DiagnosisEditDialog from "./DiagnosisEditDialog";
import PlanRelatedEditDialog from "./PlanRelatedEditDialog";
import PlanGoalsEditDialog from "./PlanGoalsEditDialog";
import PlanInterventionEditDialog from "./PlanInterventionEditDialog"
export default function NursingCarePlan() {

    const DrawerHeader = styled("div")(({ theme }) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
    }));

    const commonAutocompleteSx = {
        "& .MuiOutlinedInput-root": {
            height: 38,
        },
        "& .MuiOutlinedInput-input": {
            padding: "8px 10px",
        },
    };


    const { control, setValue, getValues } = useForm();
    const [searchBarString, setSearchBarString] = useState("");
    const [carePlanTypeOptions, setCarePlanTypeOptions] = useState([]);
    const [activeTab, setActiveTab] = useState("Diagnosis");
    const [dataResult, setDataResult] = useState([]);
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [diagnosisText, setDiagnosisText] = useState("");
    const [carePlanTypeText, setCarePlanTypeText] = useState("");
    const [selectedDiagnosisId, setSelectedDiagnosisId] = useState(null);
    const [selectedCarePlanTypeId, setSelectedCarePlanTypeId] = useState(null);
    const [diagnosisOptions, setDiagnosisOptions] = useState([]);
    const [diagnosisSearch, setDiagnosisSearch] = useState("");
    const [diagnosisData, setDiagnosisData] = useState([]);
    const [planRelatedData, setPlanRelatedData] = useState([]);
    const [planGoalsData, setPlanGoalsData] = useState([]);
    const [planInterventionData, setPlanInterventionData] = useState([]);
    const [selectedItemDetails, setSelectedItemDetails] = useState(null);
    const [openEdit, setOpenEdit] = useState(false);
    const [editTab, setEditTab] = useState(null);

    const updateDiagnosisRow = (updatedRow) => {

        setDiagnosisData(prev =>
            prev.map(row =>
                (row.id ?? row.Id) === updatedRow.id
                    ? {
                        ...row,
                        Description: updatedRow.description,
                        Active: updatedRow.active
                    }
                    : row
            )
        );
    };

    const updateRowInActiveTab = (updatedRow) => {

        const updateLogic = (prev) =>
            prev.map(row =>
                (row.id ?? row.Id) === updatedRow.id
                    ? {
                        ...row,
                        Description: updatedRow.description,
                        Active: updatedRow.active,
                        "Nursing Diagnosis":
                            updatedRow.nursingDiagnosis ??
                            row["Nursing Diagnosis"],
                        "Care Plan Type":
                            updatedRow.carePlanType ??
                            row["Care Plan Type"],
                    }
                    : row
            );

        if (activeTab === "Related Factors") {
            setPlanRelatedData(updateLogic);
        }

        if (activeTab === "Goals") {
            setPlanGoalsData(updateLogic);
        }

        if (activeTab === "Intervention") {
            setPlanInterventionData(updateLogic);
        }
    };

    const [snack, setSnack] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const isFilterSelected =
        selectedDiagnosisId && selectedCarePlanTypeId;

    const RenderActions = (row) => {

        const id =
            row?.id ??
            row?.Id ??
            row?.["Id"];

        return (
            <Box className="flex items-center gap-2">

                <Tooltip title="Edit">
                    <EditOutlinedIcon
                        sx={{ color: "#2e7d32", cursor: "pointer" }}
                        onClick={() => handleEdit(row)}
                    />
                </Tooltip>

                <Tooltip title="Delete">
                    <DeleteOutlineOutlinedIcon
                        sx={{ color: "#d32f2f", cursor: "pointer" }}
                        onClick={() => handleDelete(id)}
                    />
                </Tooltip>

            </Box>
        );
    };

    const handleDelete = (id) => {

        if (!window.confirm("Are you sure you want to delete?"))
            return;

        console.log("Delete ID 👉", id);

        // 👉 call delete API here
    };

    const handleEdit = async (row) => {
        const id =
            row?.id ??
            row?.Id ??
            row?.["Id"];

        try {

            let response;
            if (activeTab === "Diagnosis") {
                response = await diagnosisId(id);
            }

            else if (activeTab === "Related Factors") {
                response = await PlanrelatedId(id);
            }

            else if (activeTab === "Goals") {
                response = await PlanGoalsId(id);
            }

            else if (activeTab === "Intervention") {
                response = await PlaninterventionId(id);
            }

            setSelectedItemDetails(response?.data?.result?.[0]);
            setEditTab(activeTab);
            setOpenEdit(true);

        } catch (error) {
            console.error("Edit Load Error:", error);
        }
    };

    const handleNursingDiagnosisSearch = (inputValue) => {
        if (typeof inputValue !== "string") return;

        const trimmed = inputValue.trim();

        setSearchBarString(trimmed);

        if (!trimmed) {
            setDiagnosisOptions([]);
            return;
        }

        NursingDiagnosisSearchDropdown(trimmed)
            .then((res) => {
                setDiagnosisOptions(res?.data?.result ?? []);
            })
            .catch(() => {
                setDiagnosisOptions([]);
            });
    };

    const handleCarePlanType = (inputValue) => {
        if (typeof inputValue !== "string") return;

        const trimmed = inputValue.trim();

        setSearchBarString(trimmed);

        if (!trimmed) {
            setCarePlanTypeOptions([]);
            return;
        }

        CarePlanTypeSearchDropdown(trimmed)
            .then((res) => {
                setCarePlanTypeOptions(res?.data?.result ?? []);
            })
            .catch(() => {
                setCarePlanTypeOptions([]);
            });
    };

    const DiagnosispopulateTable = (forPagination) => {

        const payload = {
            page,
            size: rowsPerPage,
        };

        setOpenBackdrop(true);

        DiagnosisListing(payload)
            .then((response) => {

                const res = response?.data;

                if (forPagination) {
                    setDiagnosisData(prev => [
                        ...prev,
                        ...(res?.result ?? [])
                    ]);
                } else {
                    setDiagnosisData(res?.result ?? []);
                }

                setCount(res?.count ?? 0);
            })
            .finally(() => setOpenBackdrop(false));
    };

    const PlanRelatedFactorspopulateTable = (forPagination = false) => {
        const payload = {
            nursingDiagnosisId: selectedDiagnosisId,
            carePlanTypeId: selectedCarePlanTypeId,
            page: page + 1,
            size: rowsPerPage,
        };

        setOpenBackdrop(true);

        PlanRelatedFactorsListing(payload)
            .then((response) => {

                const res = response?.data;
                const rows = res?.result ?? [];

                if (forPagination) {
                    setPlanRelatedData(prev => [...prev, ...rows]);
                } else {
                    setPlanRelatedData(rows);
                }

                setCount(res?.count ?? 0);
            })
            .catch((error) => {
                console.error(
                    "Related Factors listing error:",
                    error
                );
                setPlanRelatedData([]);
                setCount(0);
            })
            .finally(() => {
                setOpenBackdrop(false);
            });
    };

    const PlanGoalspopulateTable = (forPagination = false) => {

        const payload = {
            nursingDiagnosisId: selectedDiagnosisId,
            carePlanTypeId: selectedCarePlanTypeId,
            page: page + 1,
            size: rowsPerPage,
        };

        setOpenBackdrop(true);

        PlanGoalsListing(payload)
            .then((response) => {

                const res = response?.data;
                const rows = res?.result ?? [];

                if (forPagination) {
                    setPlanGoalsData(prev => [...prev, ...rows]);
                } else {
                    setPlanGoalsData(rows);
                }

                setCount(res?.count ?? 0);
            })
            .catch((error) => {
                console.error("Goals listing error:", error);
                setPlanGoalsData([]);
                setCount(0);
            })
            .finally(() => {
                setOpenBackdrop(false);
            });
    };

    const PlanInterventionpopulateTable = (forPagination = false) => {

        const payload = {
            nursingDiagnosisId: selectedDiagnosisId,
            carePlanTypeId: selectedCarePlanTypeId,
            page: page + 1,
            size: rowsPerPage,
        };

        setOpenBackdrop(true);

        PlaninterventionListing(payload)
            .then((response) => {

                const res = response?.data;
                const rows = res?.result ?? [];

                if (forPagination) {
                    setPlanInterventionData(prev => [...prev, ...rows]);
                } else {
                    setPlanInterventionData(rows);
                }

                setCount(res?.count ?? 0);
            })
            .catch((error) => {
                console.error("Intervention listing error:", error);
                setPlanInterventionData([]);
                setCount(0);
            })
            .finally(() => {
                setOpenBackdrop(false);
            });
    };

    const handleAddDiagnosis = async () => {
        try {

            const values = getValues();

            const payload = {
                description: values.plan,
                active: true
            };

            const res = await DiagnosisUpdate(payload);

            const newRow = {
                Id: res?.data?.result?.Id ?? Date.now(),
                Description: values.plan,
                Active: true
            };
            setDiagnosisData(prev => [newRow, ...prev]);
            setCount(prev => prev + 1);

            setValue("plan", "");

            setSnack({
                open: true,
                message: res?.data?.message,
                severity: "success"
            });

        } catch (error) {
            console.error(error);
        }
    };

    const handleAddRelatedFactor = async () => {

        try {

            const values = getValues();

            if (!values.Diagnosis) {
                setSnack({
                    open: true,
                    message: "Please select Diagnosis",
                    severity: "warning"
                });
                return;
            }

            const payload = {
                id: null,
                description: values.planrelated || "",
                active: true,
                nursingDiagnosisId: values.Diagnosis.id,
                carePlanTypeId: values.CarePlanType?.id || 0
            };

            const res = await PlanRelatedFactorsUpdate(payload);

            const newRow = {
                Id: Date.now(),
                Description: payload.description,
                Active: true,
                "Nursing Diagnosis": values.Diagnosis.value,
                "Care Plan Type": values.CarePlanType?.value || ""
            };

            setPlanRelatedData(prev => [newRow, ...prev]);

            setCount(prev => prev + 1);

            setValue("planrelated", "");

            setSnack({
                open: true,
                message: res?.data?.message ||
                    "NursingPlanRelatedFactors saved successfully",
                severity: "success"
            });

        } catch (error) {

            setSnack({
                open: true,
                message: "Add failed",
                severity: "error"
            });
        }
    };

    const handleAddGoal = async () => {

        try {

            const values = getValues();

            if (!values.Diagnosis) {
                setSnack({
                    open: true,
                    message: "Please select Diagnosis",
                    severity: "warning"
                });
                return;
            }

            const payload = {
                id: null,
                description: values.plangols || "",
                active: true,
                nursingDiagnosisId: values.Diagnosis.id,
                carePlanTypeId: values.CarePlanType?.id || 0
            };

            console.log("ADD GOAL 👉", payload);

            const res = await PlanGolsUpdate(payload);
            const newRow = {
                Id: Date.now(),

                Description: payload.description,
                Active: true,

                "Nursing Diagnosis":
                    values.Diagnosis?.value || "",

                "Care Plan Type":
                    values.CarePlanType?.value || ""
            };

            setPlanGoalsData(prev => [newRow, ...prev]);

            setCount(prev => prev + 1);
            setValue("plangols", "");

            setSnack({
                open: true,
                message:
                    res?.data?.message ||
                    "NursingPlanGoals saved successfully",
                severity: "success"
            });

        } catch (error) {

            console.error(error);

            setSnack({
                open: true,
                message: "Goal add failed",
                severity: "error"
            });
        }
    };

    const handleAddIntervention = async () => {

        try {

            const values = getValues();

            if (!values.Diagnosis) {
                setSnack({
                    open: true,
                    message: "Please select Diagnosis",
                    severity: "warning"
                });
                return;
            }

            const payload = {
                id: null,
                description: values.planintervention || "",
                active: true,
                nursingDiagnosisId: values.Diagnosis.id,
                carePlanTypeId: values.CarePlanType?.id || 0
            };

            console.log("ADD INTERVENTION 👉", payload);

            const res = await PlaninterventionUpdate(payload);
            const newRow = {
                Id: Date.now(),

                Description: payload.description,
                Active: true,

                "Nursing Diagnosis":
                    values.Diagnosis?.value || "",

                "Care Plan Type":
                    values.CarePlanType?.value || ""
            };
            setPlanInterventionData(prev => [newRow, ...prev]);

            setCount(prev => prev + 1);

            setValue("planintervention", "");

            setSnack({
                open: true,
                message:
                    res?.data?.message ||
                    "NursingPlanIntervention saved successfully",
                severity: "success"
            });

        } catch (error) {

            console.error(error);

            setSnack({
                open: true,
                message: "Intervention add failed",
                severity: "error"
            });
        }
    };

    useEffect(() => {

        if (activeTab === "Diagnosis") {
            DiagnosispopulateTable(false);
            return;
        }

        if (!isFilterSelected) {
            setPlanRelatedData([]);
            setPlanGoalsData([]);
            setPlanInterventionData([]);
            return;
        }

        if (activeTab === "Related Factors") {
            PlanRelatedFactorspopulateTable(false);
        }

        else if (activeTab === "Goals") {
            PlanGoalspopulateTable(false);
        }

        else if (activeTab === "Intervention") {
            PlanInterventionpopulateTable(false);
        }

    }, [
        activeTab,
        selectedDiagnosisId,
        selectedCarePlanTypeId,
        page,
        rowsPerPage
    ]);

    useEffect(() => {
        setPage(0);
    }, [selectedDiagnosisId, selectedCarePlanTypeId]);

    useEffect(() => {
        setValue("Diagnosis", null);
        setValue("CarePlanType", null);
        setSelectedDiagnosisId(null);
        setSelectedCarePlanTypeId(null);
        setPlanRelatedData([]);
        setPlanGoalsData([]);
        setPlanInterventionData([]);
    }, [activeTab]);

    return (
        <Box sx={{ display: "flex" }}>
            {/* <Sidebar /> */}

            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                {/* <DrawerHeader /> */}

                <h1 className="text-xl text-black font-Poppins mb-4">
                    Nursing Care Plan Master
                </h1>

                <Box
                    sx={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        mb: 2,
                    }}
                >
                    <Box sx={{ width: 330 }}>
                        <SearchDropdown
                            control={control}
                            name="CarePlanType"
                            placeholder="Care Plan Type"
                            dataArray={carePlanTypeOptions}
                            isClearable
                            inputValue={searchBarString}
                            handleInputChange={handleCarePlanType}
                            getOptionLabel={(option) => option?.value || ""}
                            onChange={(value) => {
                                setSelectedCarePlanTypeId(value?.id || null);
                            }}
                        />
                    </Box>

                    <Box
                        sx={{
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                        }}
                    >
                        <Box
                            sx={{
                                display: "inline-flex",
                                overflow: "hidden",
                                borderRadius: "3px",
                            }}
                        >
                            {[
                                "Diagnosis",
                                "Related Factors",
                                "Goals",
                                "Intervention",
                            ].map((tab, index, arr) => (
                                <Box
                                    key={tab}
                                    onClick={() => setActiveTab(tab)}
                                    sx={{
                                        px: 2,
                                        py: 0.8,
                                        fontFamily: "Poppins, sans-serif",
                                        fontSize: "15px",
                                        fontWeight: 600,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        border: "1px solid #1e3a8a",
                                        borderRight:
                                            index !== arr.length - 1
                                                ? "none"
                                                : "1px solid #1e3a8a",
                                        borderTopLeftRadius:
                                            index === 0 ? "3px" : 0,
                                        borderBottomLeftRadius:
                                            index === 0 ? "3px" : 0,
                                        borderTopRightRadius:
                                            index === arr.length - 1 ? "3px" : 0,
                                        borderBottomRightRadius:
                                            index === arr.length - 1 ? "3px" : 0,
                                        backgroundColor:
                                            activeTab === tab
                                                ? "#1e3a8a"
                                                : "#ffffff",
                                        color:
                                            activeTab === tab
                                                ? "#ffffff"
                                                : "#1e3a8a",
                                        cursor: "pointer",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {tab}
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mt: 2,
                    }}
                >
                    <Box sx={{ width: "100%" }}>

                        {activeTab === "Diagnosis" && (
                            <div className="w-full">
                                <h3 className="text-lg text-black font-Poppins mb-2">
                                    Diagnosis Listing
                                </h3>

                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "flex-end",
                                        gap: 1,
                                        mb: 2,
                                        width: "100%",
                                    }}
                                >

                                    <Box sx={{ width: 330 }}>
                                        <InputField
                                            control={control}
                                            name="plan"
                                            label="Plan"
                                            placeholder="Plan"
                                        />
                                    </Box>

                                    <Button
                                        variant="contained"
                                        onClick={handleAddDiagnosis}
                                        sx={{
                                            minWidth: 90,
                                            height: 35,
                                            textTransform: "none",
                                            fontSize: "14px",
                                            fontWeight: 600,
                                            backgroundColor: "#1e3a8a",
                                            borderRadius: "4px",
                                        }}
                                    >
                                        Add
                                    </Button>

                                </Box>

                                {diagnosisData.length > 0 ? (
                                    <CommonTransactionPaginationTable
                                        dataResult={diagnosisData}
                                        page={page}
                                        setPage={setPage}
                                        rowsPerPage={rowsPerPage}
                                        setRowsPerPage={setRowsPerPage}
                                        count={count}
                                        renderActions={RenderActions}
                                        actionsRequired={true}
                                        highlightRow={false}
                                        populateTable={DiagnosispopulateTable}
                                        removeHeaders={["Sr No.", "srNo", "Id", "id"]}

                                    />

                                ) : (
                                    <h2 className="text-center text-gray-600 mt-20">
                                        No Data Found
                                    </h2>
                                )}


                            </div>

                        )}

                        {activeTab === "Related Factors" && (
                            <div className="w-full">
                                <h3 className="text-lg text-black font-Poppins mb-4">
                                    Related Factors Listing
                                </h3>

                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "flex-end",
                                        gap: 1,
                                        mb: 2,
                                        width: "100%",
                                    }}
                                >

                                    <Box sx={{ width: 330 }}>
                                        <SearchDropdown
                                            control={control}
                                            name="Diagnosis"
                                            placeholder="Diagnosis"
                                            isClearable
                                            dataArray={diagnosisOptions}
                                            inputValue={diagnosisSearch}
                                            handleInputChange={handleNursingDiagnosisSearch}
                                            getOptionLabel={(option) => option?.value || ""}
                                            onChange={(value) =>
                                                setSelectedDiagnosisId(value?.id || null)
                                            }
                                        />
                                    </Box>

                                    <Box sx={{ width: 330 }}>
                                        <InputField
                                            control={control}
                                            name="planrelated"
                                            label="Plan"
                                            placeholder="Plan"
                                        />
                                    </Box>

                                    <Button
                                        variant="contained"
                                        onClick={handleAddRelatedFactor}
                                        sx={{
                                            minWidth: 90,
                                            height: 35,
                                            textTransform: "none",
                                            fontSize: "14px",
                                            fontWeight: 600,
                                            backgroundColor: "#1e3a8a",
                                            borderRadius: "4px",
                                        }}
                                    >
                                        Add
                                    </Button>

                                </Box>

                                {isFilterSelected ? (

                                    planRelatedData.length > 0 ? (
                                        <CommonTransactionPaginationTable
                                            dataResult={planRelatedData}
                                            page={page}
                                            setPage={setPage}
                                            rowsPerPage={rowsPerPage}
                                            setRowsPerPage={setRowsPerPage}
                                            count={count}
                                            actionsRequired={true}
                                            highlightRow={false}
                                            renderActions={RenderActions}
                                            populateTable={PlanRelatedFactorspopulateTable}
                                            removeHeaders={["Sr No.", "srNo", "Id", "id"]}
                                        />
                                    ) : (
                                        <h2 className="text-center text-gray-600 mt-20">
                                            No Data Found
                                        </h2>
                                    )

                                ) : (
                                    <h2 className="text-center text-gray-600 mt-20">
                                        Please select Care Plan Type & Diagnosis
                                    </h2>
                                )}

                            </div>
                        )}

                        {activeTab === "Goals" && (
                            <div className="w-full">
                                <h3 className="text-lg text-black font-Poppins mb-4">
                                    Goals Listing
                                </h3>

                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "flex-end",
                                        gap: 1,
                                        mb: 2,
                                        width: "100%",
                                    }}
                                >

                                    <Box sx={{ width: 330 }}>
                                        <SearchDropdown
                                            control={control}
                                            name="Diagnosis"
                                            placeholder="Diagnosis"
                                            isClearable
                                            dataArray={diagnosisOptions}
                                            inputValue={diagnosisSearch}
                                            handleInputChange={handleNursingDiagnosisSearch}
                                            getOptionLabel={(option) => option?.value || ""}
                                            onChange={(value) =>
                                                setSelectedDiagnosisId(value?.id || null)
                                            }
                                        />
                                    </Box>

                                    <Box sx={{ width: 330 }}>
                                        <InputField
                                            control={control}
                                            name="plangols"
                                            label="Plan"
                                            placeholder="Plan"
                                        />
                                    </Box>

                                    <Button
                                        variant="contained"
                                        onClick={handleAddGoal}
                                        sx={{
                                            minWidth: 90,
                                            height: 35,
                                            textTransform: "none",
                                            fontSize: "14px",
                                            fontWeight: 600,
                                            backgroundColor: "#1e3a8a",
                                            borderRadius: "4px",
                                        }}
                                    >
                                        Add
                                    </Button>

                                </Box>

                                {isFilterSelected ? (

                                    planGoalsData.length > 0 ? (
                                        <CommonTransactionPaginationTable
                                            dataResult={planGoalsData}
                                            page={page}
                                            setPage={setPage}
                                            rowsPerPage={rowsPerPage}
                                            setRowsPerPage={setRowsPerPage}
                                            count={count}
                                            renderActions={RenderActions}
                                            actionsRequired
                                            highlightRow={false}
                                            populateTable={PlanGoalspopulateTable}
                                            removeHeaders={["Sr No.", "srNo", "Id", "id"]}
                                        />
                                    ) : (
                                        <h2 className="text-center mt-20">
                                            No Data Found
                                        </h2>
                                    )

                                ) : (
                                    <h2 className="text-center mt-20">
                                        Please select Care Plan Type & Diagnosis
                                    </h2>
                                )}

                            </div>
                        )}

                        {activeTab === "Intervention" && (
                            <div className="w-full">
                                <h3 className="text-lg text-black font-Poppins mb-4">
                                    Intervention Listing
                                </h3>

                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "flex-end",
                                        gap: 1,
                                        mb: 2,
                                        width: "100%",
                                    }}
                                >

                                    <Box sx={{ width: 330 }}>
                                        <SearchDropdown
                                            control={control}
                                            name="Diagnosis"
                                            placeholder="Diagnosis"
                                            isClearable
                                            dataArray={diagnosisOptions}
                                            inputValue={diagnosisSearch}
                                            handleInputChange={handleNursingDiagnosisSearch}
                                            getOptionLabel={(option) => option?.value || ""}
                                            onChange={(value) =>
                                                setSelectedDiagnosisId(value?.id || null)
                                            }
                                        />
                                    </Box>

                                    <Box sx={{ width: 330 }}>
                                        <InputField
                                            control={control}
                                            name="planintervention"
                                            label="Plan"
                                            placeholder="Plan"
                                        />
                                    </Box>

                                    <Button
                                        variant="contained"
                                        onClick={handleAddIntervention}
                                        sx={{
                                            minWidth: 90,
                                            height: 35,
                                            textTransform: "none",
                                            fontSize: "14px",
                                            fontWeight: 600,
                                            backgroundColor: "#1e3a8a",
                                            borderRadius: "4px",
                                        }}
                                    >
                                        Add
                                    </Button>

                                </Box>

                                {isFilterSelected ? (

                                    planInterventionData.length > 0 ? (
                                        <CommonTransactionPaginationTable
                                            dataResult={planInterventionData}
                                            page={page}
                                            setPage={setPage}
                                            rowsPerPage={rowsPerPage}
                                            setRowsPerPage={setRowsPerPage}
                                            count={count}
                                            renderActions={RenderActions}
                                            actionsRequired
                                            highlightRow={false}
                                            populateTable={PlanInterventionpopulateTable}
                                            removeHeaders={["Sr No.", "srNo", "Id", "id"]}
                                        />
                                    ) : (
                                        <h2 className="text-center text-gray-600 mt-20">
                                            No Data Found
                                        </h2>
                                    )

                                ) : (
                                    <h2 className="text-center text-gray-600 mt-20">
                                        Please select Care Plan Type & Diagnosis
                                    </h2>
                                )}

                            </div>
                        )}

                        {openEdit && editTab === "Diagnosis" && (
                            <DiagnosisEditDialog
                                open={openEdit}
                                data={selectedItemDetails}
                                onClose={() => setOpenEdit(false)}
                                setSnack={setSnack}
                                onUpdateSuccess={updateDiagnosisRow}
                            />
                        )}

                        {openEdit && editTab === "Related Factors" && (
                            <PlanRelatedEditDialog
                                open={openEdit}
                                data={selectedItemDetails}
                                onClose={() => setOpenEdit(false)}
                                setSnack={setSnack}
                                onUpdateSuccess={updateRowInActiveTab}
                            />
                        )}

                        {openEdit && editTab === "Goals" && (
                            <PlanGoalsEditDialog
                                open={openEdit}
                                data={selectedItemDetails}
                                onClose={() => setOpenEdit(false)}
                                setSnack={setSnack}
                                onUpdateSuccess={updateRowInActiveTab}
                            />
                        )}

                        {openEdit && editTab === "Intervention" && (
                            <PlanInterventionEditDialog
                                open={openEdit}
                                data={selectedItemDetails}
                                onClose={() => setOpenEdit(false)}
                                setSnack={setSnack}
                                onUpdateSuccess={updateRowInActiveTab}
                            />
                        )}

                        <Snackbar
                            open={snack.open}
                            autoHideDuration={4000}
                            onClose={() => setSnack({ ...snack, open: false })}
                            anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        >
                            <Alert
                                onClose={() => setSnack({ ...snack, open: false })}
                                severity={snack.severity}
                                variant="filled"
                                sx={{ width: "100%" }}
                            >
                                {snack.message}
                            </Alert>
                        </Snackbar>
                    </Box>

                </Box>

            </Box>
        </Box >
    );
}